// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chester-toggle {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  background-color: #df2d11;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  z-index: 1002; /* Increase from 1001 to be above other elements */
  box-sizing: border-box;
  padding: 0;
  display: flexbox;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease;  /* Add transition */
}

.chester-toggle:hover {
  transform: scale(1.05);  /* Add hover effect */
}

@media (max-width: 576px) {
  .chester-toggle {
    right: 16px;
  }
}

.chester-toggle svg {
  width: 30px;
  height: 30px;
  position: relative;
  top: 3px;
  color: #fff !important;
}

.chester-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  position: fixed;
  bottom: 90px;
  right: 20px;
  width: 625px;
  max-height: 600px;
  background-color: #faf8f5;
  border-radius: 12px;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.06);
  z-index: 1002; /* Increase from 1000 to be above other elements */
  padding: 24px 32px;
  box-sizing: border-box;
  min-height: 400px;
}

@media (max-width: 576px) {
  .chester-container {
    right: 16px;
    width: calc(100% - 32px);
    max-height: calc(100vh - 64px - 90px);
    padding: 24px 16px;
  }
}

.chester-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  width: calc(100% + 40px);
  margin-left: -20px;
  z-index: -1;
}

.message {
  padding: 10px 16px;
  background-color: #fff;
  margin-bottom: 12px;
  border-radius: 12px;
  font-size: 16px;
  font-family: 'Crimson', serif;
}

.message.user {
  text-align: left;
  font-family: "Gabarito", serif;
  font-size: 14px;
  background-color: #ded8d1;
  width: fit-content;
  position: relative;
  margin-top: 30px;
}

.message.bot {
  text-align: left;
  color: black;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);
  position: relative;
  padding-left: 40px;
  font-size: 16px;
}

.message.bot::before {
  content: '';
  position: absolute;
  left: 12px;
  top: 11px;
  width: 20px;
  height: 20px;
  background-color: #b19f95;
  border-radius: 50px;
}

.message.bot::after {
  position: absolute;
  left: 17px;
  top: 11px;
  z-index: 1;
  display: inline-block;
  width: 16px;
  height: 16px;
  font-size: 14px;
  content: "C";
  font-family: "Gabarito", serif;
}

.message pre {
  all: unset;
}

.chester-input {
  display: flex;
  align-items: center;
  background-color: #fff;
  box-shadow: 0px 5px 20px 0px #ded8d1;
  padding: 12px;
  border-radius: 16px;
  font-family: "Gabarito", serif;
  /* margin-top: 20px; */
  position: relative;
}

.chester-input::before {
  content: '';
  position: absolute;
  top: -20px;
  left: 0;
  right: 0;
  height: 30px;
  width: 100%;
  background: linear-gradient(to bottom, transparent, #faf8f5 60%);
  z-index: -1;
}

.chester-input input {
  flex: 4 1;
  padding: 5px;
  border: none;
}

.chester-input button {
  border: none;
  /* background-color: #f3f2ea;
  color: #898989; */
  background-color: #df2d11;
  color: #fff;
  border-radius: 12px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chester-input button:hover {
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
} 

.chester-header {
  display: flex;
  align-items: center;
  margin-top: -24px;
  background-color: #fff;
  width: calc(100% + 64px);
  margin-left: -32px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  padding: 8px 32px;
  border-bottom: 1px solid rgba(135, 134, 127, 0.25);
  /* margin-bottom: 20px; */
  gap: 16px;
}

@media (max-width: 576px) {
  .chester-header {
    width: calc(100% + 32px);
    margin-left: -16px;
  }
}

.chester-header-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.chester-header span {
  font-family: 'Crimson', serif;
  font-size: 20px;
  line-height: 1;
}

.chester-header p {
  line-height: 1;
  margin: 0;
  font-family: "Gabarito", serif;
  color: #454545;
  font-size: 14px; 
}

.chester-header-avatar {
  width: 50px;
  height: 50px;
  background-color: #faf8f5;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(135, 134, 127, 0.25);
}

.chester-header img {
  max-width: 40px;
}

.loading-message {
  position: relative;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.loading-message > div {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ded8d1;
  animation: bounce 1.2s infinite ease-in-out;
}

/* First dot (Left) */
.loading-message > div:first-child {
  animation-delay: 0s;
}

/* Second dot (Center) */
.loading-message > div:nth-child(2) {
  animation-delay: 0.2s;
}

/* Third dot (Right) */
.loading-message > div:last-child {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(1);
  }
  40% {
    transform: scale(1.2);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Chester.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa,EAAE,kDAAkD;EACjE,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;EAC/C,+BAA+B,GAAG,mBAAmB;AACvD;;AAEA;EACE,sBAAsB,GAAG,qBAAqB;AAChD;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gDAAgD;EAChD,aAAa,EAAE,kDAAkD;EACjE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE;IACE,WAAW;IACX,wBAAwB;IACxB,qCAAqC;IACrC,kBAAkB;EACpB;AACF;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,gEAAgE;EAChE,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ;mBACiB;EACjB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,iBAAiB;EACjB,kDAAkD;EAClD,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE;IACE,wBAAwB;IACxB,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".chester-toggle {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  width: 60px;\n  height: 60px;\n  background-color: #df2d11;\n  border: none;\n  border-radius: 50px;\n  cursor: pointer;\n  z-index: 1002; /* Increase from 1001 to be above other elements */\n  box-sizing: border-box;\n  padding: 0;\n  display: flexbox;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.3);\n  transition: transform 0.2s ease;  /* Add transition */\n}\n\n.chester-toggle:hover {\n  transform: scale(1.05);  /* Add hover effect */\n}\n\n@media (max-width: 576px) {\n  .chester-toggle {\n    right: 16px;\n  }\n}\n\n.chester-toggle svg {\n  width: 30px;\n  height: 30px;\n  position: relative;\n  top: 3px;\n  color: #fff !important;\n}\n\n.chester-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: stretch;\n  position: fixed;\n  bottom: 90px;\n  right: 20px;\n  width: 625px;\n  max-height: 600px;\n  background-color: #faf8f5;\n  border-radius: 12px;\n  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.06);\n  z-index: 1002; /* Increase from 1000 to be above other elements */\n  padding: 24px 32px;\n  box-sizing: border-box;\n  min-height: 400px;\n}\n\n@media (max-width: 576px) {\n  .chester-container {\n    right: 16px;\n    width: calc(100% - 32px);\n    max-height: calc(100vh - 64px - 90px);\n    padding: 24px 16px;\n  }\n}\n\n.chester-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n  width: calc(100% + 40px);\n  margin-left: -20px;\n  z-index: -1;\n}\n\n.message {\n  padding: 10px 16px;\n  background-color: #fff;\n  margin-bottom: 12px;\n  border-radius: 12px;\n  font-size: 16px;\n  font-family: 'Crimson', serif;\n}\n\n.message.user {\n  text-align: left;\n  font-family: \"Gabarito\", serif;\n  font-size: 14px;\n  background-color: #ded8d1;\n  width: fit-content;\n  position: relative;\n  margin-top: 30px;\n}\n\n.message.bot {\n  text-align: left;\n  color: black;\n  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);\n  position: relative;\n  padding-left: 40px;\n  font-size: 16px;\n}\n\n.message.bot::before {\n  content: '';\n  position: absolute;\n  left: 12px;\n  top: 11px;\n  width: 20px;\n  height: 20px;\n  background-color: #b19f95;\n  border-radius: 50px;\n}\n\n.message.bot::after {\n  position: absolute;\n  left: 17px;\n  top: 11px;\n  z-index: 1;\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  font-size: 14px;\n  content: \"C\";\n  font-family: \"Gabarito\", serif;\n}\n\n.message pre {\n  all: unset;\n}\n\n.chester-input {\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  box-shadow: 0px 5px 20px 0px #ded8d1;\n  padding: 12px;\n  border-radius: 16px;\n  font-family: \"Gabarito\", serif;\n  /* margin-top: 20px; */\n  position: relative;\n}\n\n.chester-input::before {\n  content: '';\n  position: absolute;\n  top: -20px;\n  left: 0;\n  right: 0;\n  height: 30px;\n  width: 100%;\n  background: linear-gradient(to bottom, transparent, #faf8f5 60%);\n  z-index: -1;\n}\n\n.chester-input input {\n  flex: 4;\n  padding: 5px;\n  border: none;\n}\n\n.chester-input button {\n  border: none;\n  /* background-color: #f3f2ea;\n  color: #898989; */\n  background-color: #df2d11;\n  color: #fff;\n  border-radius: 12px;\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.chester-input button:hover {\n  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);\n} \n\n.chester-header {\n  display: flex;\n  align-items: center;\n  margin-top: -24px;\n  background-color: #fff;\n  width: calc(100% + 64px);\n  margin-left: -32px;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  padding: 8px 32px;\n  border-bottom: 1px solid rgba(135, 134, 127, 0.25);\n  /* margin-bottom: 20px; */\n  gap: 16px;\n}\n\n@media (max-width: 576px) {\n  .chester-header {\n    width: calc(100% + 32px);\n    margin-left: -16px;\n  }\n}\n\n.chester-header-content {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.chester-header span {\n  font-family: 'Crimson', serif;\n  font-size: 20px;\n  line-height: 1;\n}\n\n.chester-header p {\n  line-height: 1;\n  margin: 0;\n  font-family: \"Gabarito\", serif;\n  color: #454545;\n  font-size: 14px; \n}\n\n.chester-header-avatar {\n  width: 50px;\n  height: 50px;\n  background-color: #faf8f5;\n  border-radius: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid rgba(135, 134, 127, 0.25);\n}\n\n.chester-header img {\n  max-width: 40px;\n}\n\n.loading-message {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n}\n\n.loading-message > div {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: #ded8d1;\n  animation: bounce 1.2s infinite ease-in-out;\n}\n\n/* First dot (Left) */\n.loading-message > div:first-child {\n  animation-delay: 0s;\n}\n\n/* Second dot (Center) */\n.loading-message > div:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n/* Third dot (Right) */\n.loading-message > div:last-child {\n  animation-delay: 0.4s;\n}\n\n@keyframes bounce {\n  0%, 80%, 100% {\n    transform: scale(1);\n  }\n  40% {\n    transform: scale(1.2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
